module.exports = __webpack_public_path__ + "media/images/icons/map-marker--orange-fae4c75ee6b547cd10c09e40d8a1478a.png";